export const baseUrl = '/kux/index'

export const getPostListUrl = '/kux/index/allList'

export const getPostUrl = '/kux/index/infor'

export const getBannerUrl = '/kux/index/top'

export const loginUrl = '/kux/index/login'

export const logoutUrl = '/kux/index/logout'

export const commentUrl = '/kux/index/comment'

export const queryUploadUrl = 'https://ikd.kingdee.com/uploads/public'
export const queryUploadFileUrl = 'https://ikd.kingdee.com/uploads/private'

export const getAvatarUrl = '/kdrive/user/file/public/url'

export const getSmallAvatarUrl = '/kdrive/user/file/thumbnail/url?width=535'

export const postArticleUrl = '/post'

export const deletePostUrl = '/delete'

export const submitPostUrl = '/auditState/2?id='

export const reasonPostUrl = '/reason'

export const updateArticleUrl = '/post/update'

export const getUserPostUrl = '/kux/useList'

export const getUserAuditPostUrl = '/kux/prepare?auditState=2'

export const getArticlePermissionUrl = '/kux/p-menu'

export const getArticleTagsUrl = '/tags'

export const getCategory2Url = '/kux/index/menu?type=588470ad08ec05162c2e18c1'

export const addTagsUrl = '/tags/add'

export const likeUrl = '/collect' // 收藏或者点赞

export const likeCommentUrl = '/likecomment'

export const attachMentUrl = '/kux/get_document_url'

export const getCourseBannerUrl = '/kux/course/banner'

export const getUserInforUrl = '/kux/infor'

export const setUserInforUrl = '/kux/infor/edit'

export const hotUsersUrl = '/hotUsers'

export const rankCoursesUrl = '/rankCourses'

export const getVersionUrl = 'https://kui.kingdee.com/api/kd/vers?appid=200551'

